import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
} from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import { Router } from "@angular/router";
import {
  CredentialVerification,
  ICredentialVerification,
} from "./../../../shared/models/products/credential-verification";
import { Address, IAddress } from "./../../../shared/models/address";

import { UserService } from "./../../../../shared/services/user.service";
import { PurchaseService } from "./../../../shared/services/purchase.service";
import { ViewStateService } from "./../../../../shared/services/view-state.service";
import { PurchaseStateService } from "./../../../shared/services/purchase-state.service";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-self",
  templateUrl: "./self.component.html",
})
export class SelfComponent implements OnInit, OnDestroy {
  personId: string;
  address: IAddress;
  product: ICredentialVerification;
  private destroy$ = new Subject<void>();

  constructor(
    private purchaseService: PurchaseService,
    private viewState: ViewStateService,
    private userService: UserService,
    private purchaseState: PurchaseStateService,
    private router: Router
  ) {}

  ngOnInit() {
    this.viewState.startLoading();

    this.personId = this.userService.CurrentUser.personId;

    this.product = <CredentialVerification>(
      this.purchaseState.getTempProductData()
    );

    this.retrieveUserInformation();
  }

  isExpired(): boolean {
    if (
      this.userService.CurrentUser.hasExpiredCredentials &&
      !this.userService.CurrentUser.credentialHolder
    ) {
      return true;
    }
    return false;
  }

  private retrieveUserInformation(): void {
    this.purchaseService
      .getProfile(this.personId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.address = new Address();
        this.address.line1 = res.line1;
        this.address.line2 = res.line2;
        this.address.line3 = res.line3;
        this.address.city = res.city;
        this.address.state = res.stateProvince;
        this.address.postalCode = res.zip;

        this.viewState.stopLoading();
      });
  }

  onSubmit() {
    this.product.sendTo = this.address || new Address();
    this.purchaseState.patchProducts(this.product);
    this.router.navigate(["purchase/checkout"]);
  }

  onBack(event: Event) {
    event.preventDefault();

    this.router.navigate([this.purchaseState.previousRouteUrl]);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
